import {
  useEndorsementSelector,
  selectIsViewOnly,
} from "@redux/slices/endorsement";

/** Insured tab state — read-only in the `issue` and `review` modes. */
export const useInsuredTab = () => {
  return {
    viewOnly: useEndorsementSelector(selectIsViewOnly),
  };
};
